export default __webpack_public_path__ + "static/media/subscribe_bg.2a5c6df5.jpg";